class ConstantsParams {
  static UserTypeTerminalStatus = {
    NONE: 0,
    VIEWER: 1,
    EDITOR: 2,
    MANAGER: 3,
  };

  static ActionTypes = {
    NEW: "new",
    CREATE: "create",
    UPDATE: "update",
    CANCEL: "cancel",
    BASE_MODEL: "base_model",
    UPLOAD_POLYGON: "upload_polygon",
    DELETE: "delete",
    DELETE_VERSION: "delete_version",
    FREEZE_VERSION: "freeze_version",
  };
}

export default ConstantsParams;
